var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCvc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E1E0DC",
    d: "M17.093 7H6.906A1.898 1.898 0 0 0 5 8.885v6.23C5 16.156 5.855 17 6.906 17h10.187A1.898 1.898 0 0 0 19 15.116V8.885C19 7.845 18.145 7 17.093 7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADADAD",
    d: "M5 9h14v2H5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40423F",
    fillRule: "nonzero",
    d: "M13.941 15v-2.085h-.228a.42.42 0 0 1-.423.339h-.066v.243h.108c.114 0 .276-.045.339-.132V15h.27zm1.958 0v-.243h-1.005a4.33 4.33 0 0 0 .513-.411c.321-.297.468-.552.468-.846 0-.405-.243-.63-.648-.63-.42 0-.672.237-.672.606 0 .054.006.108.021.168l.27.027a1.01 1.01 0 0 1-.024-.192c0-.228.147-.375.39-.375.24 0 .381.144.381.399 0 .249-.09.423-.354.678a7.665 7.665 0 0 1-.708.597V15h1.368zm1.118.045c.435 0 .708-.237.708-.636 0-.297-.159-.462-.45-.513a.475.475 0 0 0 .378-.48c0-.339-.237-.546-.645-.546-.426 0-.69.246-.69.648l.252.054c0-.309.153-.477.423-.477.246 0 .39.129.39.351 0 .222-.129.36-.408.36h-.105v.222h.117c.312 0 .468.138.468.387 0 .264-.147.405-.429.405-.288 0-.471-.165-.483-.447l-.264.033c.012.39.303.639.738.639z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvc);
export default __webpack_public_path__ + "static/media/cvc.40e54fd805f3ae082283320b951ce677.svg";
export { ForwardRef as ReactComponent };